import { Http } from "./http.init";
import $store from "../store";

export class AuthService {
  static get entity() {
    return "auth";
  }

  /**
   ******************************
   * @API
   ******************************
   */

  static async login({ username, password }) {
    const response = await new Http().post(`${this.entity}/login`, {
      username,
      password
    });
    await _setAuthData({
      accessToken: response.data.access_token,
      exp: _parseTokenData(response.data.access_token).exp
    });

    return response.data;
  }

  static async register({ mobile, password, passwordConfirm }) {
    const response = await new Http().post(`${this.entity}/register`, {
      mobile,
      password,
      passwordConfirm
    });
    return response.data;
  }

  static async logout() {
    const response = await new Http({ auth: true }).post(
      `${this.entity}/logout`,
      {}
    );
    _resetAuthData();
    return response.data;
  }

  static async getUserInfo() {
    const response = await new Http({ auth: true }).get(`${this.entity}/me`);
    return response.data;
  }

  static async refreshTokens() {
    try {
      const response = await new Http().post(
        `${this.entity}/refresh-tokens`,
        {}
      );

      _setAuthData({
        accessToken: response.data.data.accessToken,
        exp: _parseTokenData(response.data.data.accessToken).exp
      });
      return response.data;
    } catch (error) {
      _resetAuthData();
      throw error;
    }
  }
  static async loginSocial(token, type) {
    let path = "";
    if (type === "facebook") {
      path = "/auth/facebook";
    } else if (type === "google") {
      path = "/auth/google";
    } else return false;
    return new Http().post(path, { access_token: token }).then(response => {
      if (!response) {
        return;
      }
      $store.commit("auth/SET_AUTH", response.data);
    });
  }

  static async sendEmailResetPass(payload) {
    const response = await new Http({ auth: true }).post(
      `/email-reset-password`,
      payload
    );
    return response.data;
  }
  static async forgotPassword(payload) {
    const response = await new Http({ auth: true }).post(
      `/forgot-password`,
      payload
    );
    return response.data;
  }
  static async resetPassword(payload) {
    const response = await new Http({ auth: true }).post(
      `/reset-password`,
      payload
    );
    return response.data;
  }

  static debounceRefreshTokens() {
    return this._debounce(() => {
      return this.refreshTokens();
    }, 100);
  }

  /**
   ******************************
   * @METHODS
   ******************************
   */

  // static isAccessTokenExpired() {
  //   const accessTokenExpDate = this.$store.state.auth.accessTokenExpDate - 10;
  //   const nowTime = Math.floor(new Date().getTime() / 1000);
  //
  //   return accessTokenExpDate <= nowTime;
  // }

  // static hasRefreshToken() {
  //   return Boolean(localStorage.getItem("refreshToken"));
  // }

  static setRefreshToken(status) {
    if (!["", "true"].includes(status)) {
      throw new Error(
        `setRefreshToken: invalid value ${status}; Expect one of ['', 'true']`
      );
    }

    localStorage.setItem("refreshToken", status);
  }

  static getBearer() {
    return `Bearer ${$store.state.auth.access_token}`;
  }

  /**
   * https://stackoverflow.com/questions/35228052/debounce-function-implemented-with-promises
   * @param inner
   * @param ms
   * @returns {function(...[*]): Promise<unknown>}
   * @private
   */
  static _debounce(inner, ms = 0) {
    let timer = null;
    let resolves = [];

    return function() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const result = inner();
        resolves.forEach(r => r(result));
        resolves = [];
      }, ms);

      return new Promise(resolve => resolves.push(resolve));
    };
  }
}

/**
 ******************************
 * @private_methods
 ******************************
 */

function _parseTokenData(accessToken) {
  let payload = "";
  let tokenData = {};

  try {
    payload = accessToken.split(".")[1];
    tokenData = JSON.parse(atob(payload));
  } catch (error) {
    throw new Error(error);
  }

  return tokenData;
}

function _resetAuthData() {
  // reset userData in store
  $store.commit("auth/DESTROY_AUTH");
  // reset tokens
  AuthService.setRefreshToken("");
}

function _setAuthData({ accessToken, exp } = {}) {
  AuthService.setRefreshToken("true");
  $store.commit("auth/SET_AUTH", {
    hasAccess: true,
    access_token: accessToken,
    accessTokenExpDate: exp
  });
}
